import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { updateScannerCredentialFields } from './scannerCredentialFields.endpoints';
import { getScannerCredentialFieldsQueryKey } from './scannerCredentialFields.queryKeys';

export function useUpdateScannerCredentialFields() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateScannerCredentialFields,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(getScannerCredentialFieldsQueryKey(variables), data);
    },
  });
}
